import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

function formatErr(detail) {
  if (!detail) return "Algo salió mal.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" · ");
  return JSON.stringify(detail);
}

export default function LoginLiderVial() {
  const navigate = useNavigate();
  const { loginLiderVial } = useAuth();
  const [nEmpleado, setNEmpleado] = useState("");
  const [nUnidad, setNUnidad] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await loginLiderVial(nEmpleado.trim(), nUnidad.trim());
      navigate("/vialidades");
    } catch (err) {
      setError(formatErr(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="page-login-lider-vial">
      <div className="login-admin-bg">
        <div className="login-card fade-up" data-testid="login-lider-card">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 rounded-2xl bg-white text-orange-700 grid place-items-center text-xl">
              <i className="fa-solid fa-road"/>
            </div>
            <div>
              <div className="text-xs uppercase tracking-widest opacity-80">DMU 614 · Vialidades</div>
              <h1>Líder de Cuadrilla</h1>
            </div>
          </div>

          <p className="text-sm opacity-85 mb-6">
            Ingresa con tu N° de empleado y N° de unidad asignada.
          </p>

          <form onSubmit={submit} className="space-y-4" data-testid="form-login-lider-vial">
            <div className="field">
              <label htmlFor="lv-emp">N° empleado</label>
              <input id="lv-emp" type="text" inputMode="numeric" autoComplete="username"
                     value={nEmpleado} onChange={(e) => setNEmpleado(e.target.value)}
                     placeholder="Ej: 12345" data-testid="lv-empleado" required/>
            </div>
            <div className="field">
              <label htmlFor="lv-uni">N° unidad</label>
              <input id="lv-uni" type="text" inputMode="numeric" autoComplete="off"
                     value={nUnidad} onChange={(e) => setNUnidad(e.target.value)}
                     placeholder="Ej: 12799" data-testid="lv-unidad" required/>
            </div>
            {error && <div className="login-error" data-testid="lv-error">{error}</div>}
            <button type="submit" className="btn-primary" disabled={loading} data-testid="lv-submit">
              {loading ? "Entrando…" : "ENTRAR"}
              {!loading && <i className="fa-solid fa-arrow-right"/>}
            </button>
          </form>

          <div className="mt-6 pt-5 border-t border-white/20 text-center">
            <Link to="/" className="text-sm opacity-80 hover:opacity-100" data-testid="lv-back">
              <i className="fa-solid fa-arrow-left"/> Volver al login principal
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
